import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DatasetFacade } from '@mode/dataset/contract';
import { SwitchViewFacade } from '@mode/switch-views/contract';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'mode-dataset-edit',
  templateUrl: './dataset-edit.component.html',
  styleUrls: ['./dataset-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasetEditComponent implements OnInit {
  switchViewToken$ = this.datasetFacade.dataset$.pipe(map((dataset) => dataset?.result?.switchViewToken));
  isAccessDenied$ = this.datasetFacade.loadDatasetError$.pipe(map((error) => error?.status === 403));
  lastSynced$ = this.datasetFacade.dataset$.pipe(map((dataset) => dataset?.result?.completedAt));

  header = 'The latest data was removed';
  subtext = 'This was a result of your Workspace’s data retention policy. Sync again to load new results.';
  icon = 'illo-air-ballon';

  constructor(
    public datasetFacade: DatasetFacade,
    private switchViewFacade: SwitchViewFacade
  ) {}

  ngOnInit(): void {
    this.datasetFacade.dataset$
      .pipe(take(1))
      .subscribe((dataset) => this.switchViewFacade.queryRawDataset(dataset.result.queryToken));
  }
}
